import * as types from '../types';
import * as oaApi from '../../http/oaApi';
import that from '../../main';
import {
    Message
} from 'element-ui';

const state = {
    userInfo: {},
    menuList: [],

    uploadUrl: '',
    isChange: false,
    avatar: "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
    logining: false
};

const mutations = {
    [types.LOG_GETUSERINFO](state, status) {
        state.userInfo = Object.assign({}, status);
    },
    [types.INDEX_GETMENULIST](state, status) {
        state.menuList = [...status];
    },
    [types.LOG_GETAVATAR](state, data) {
        state.avatar = `https://uc-api.loratech.cn/dingtalk/2/user/${encodeURIComponent(data.name)}/avatar/100`;
    },
    [types.LOGINING](state, bol) {
        state.logining = bol;
    },
};

const getters = {
    // userInfo: state => state.userInfo,
    // roles: state => state.userInfo.user_type
};

const actions = {
    /**
     * 获取用户信息
     */

    getUserInfo({
        commit,
        dispatch,
        rootState
    }) {
        let user_id = localStorage.getItem('user_id');
        oaApi.user({}, 'get', user_id).then(res => {
            if (res) {
                localStorage.setItem('userInfo', JSON.stringify(res.data));
                dispatch('getMenuListByRoles');
                commit(types.LOG_GETUSERINFO, res.data);
                commit(types.LOG_GETAVATAR, res.data);
            }
        });
    },
    /**
     * 获取菜单列表
     */
    getMenuListByRoles({
        commit,
        state
    }) {
        commit(types.LOGINING, true);
        oaApi.authority({}, 'get').then(res => {
            if (res) {
                let menu_list = res.data;
                localStorage.setItem('menu_list', JSON.stringify(menu_list));
                let activeTab = localStorage.getItem('activeTab');
                let path = '';
                if (menu_list && menu_list[0] && menu_list[0].child) {
                    if (menu_list[0].child[0].child) {
                        path = menu_list[0].child[0].child[0].url;
                    } else {
                        path = menu_list[0].child[0].url;
                    }
                } else {
                    path = menu_list[0].url;
                }
                commit(types.INDEX_GETMENULIST, res.data);
                commit(types.LOGINING, false);
                if (state.isChange) {
                    that.$router.push(path);
                } else {
                    if (activeTab && activeTab.length) {
                        that.$router.push('/' + activeTab);
                    } else {
                        that.$router.push(path);
                    }
                }
            }
        });
    }
};

export default {
    state,
    actions,
    getters,
    mutations
};